<template>
  <div>
    <v-dialog v-model="signatureErrorDialog" max-width="300px">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="blue-grey darken-3"
          dark
        >
          <div class="grey--text text--lighten-1 text-body-2 mb-4">
            {{
              $t(
                'Não foi possível assinar a Ordem de Serviço, você não possui assinatura cadastrada no sistema. Gostaria de fechar a Ordem de Serviço sem assinar?'
              )
            }}
          </div>

          <v-btn
            :disabled="loading"
            class="ma-1"
            color="grey"
            text
            @click="signatureErrorDialog = false"
          >
            {{ $t('Não') }}
          </v-btn>

          <v-btn
            :loading="loading"
            class="ma-1"
            color="#B14949"
            text
            @click="submit"
          >
            {{ $t('Sim') }}
          </v-btn>
        </v-sheet>
      </div>
    </v-dialog>

    <v-dialog v-model="signatureConfirmDialog" max-width="400">
      <div class="text-center">
        <v-sheet
          class="px-7 pt-7 pb-4 mx-auto text-center d-inline-block"
          color="white"
          style="width: 100%"
        >
          <h3 class="mb-4">
            {{ $t('Gostaria de assinar como Técnico Executor?') }}
          </h3>

          <v-divider></v-divider>
          <div class="d-flex justify-center">
            <v-radio-group v-model="option">
              <v-radio :value="0">
                <template v-slot:label>
                  <span class="black--text text-body-2">
                    {{ $t('Usar assinatura do usuário logado') }}
                  </span>
                </template>
              </v-radio>
              <v-radio :value="1">
                <template v-slot:label>
                  <span class="black--text text-body-2">
                    {{ $t('Assinar via touchscreen') }}
                  </span>
                </template>
              </v-radio>
              <v-radio :value="2">
                <template v-slot:label>
                  <span class="black--text text-body-2">
                    {{ $t('Usar assinatura do responsável pela O.S.') }}
                  </span>
                </template>
              </v-radio>
            </v-radio-group>
          </div>

          <v-expand-transition>
            <div v-if="option == 1">
              <SignatureScreen
                v-model="currentChecklist.executorName"
                @save="validateExecutorChecklist"
              />
            </div>
          </v-expand-transition>

          <div
            v-if="option == 0 || option == 2"
            class="d-flex justify-space-between mt-2"
          >
            <v-btn
              :disabled="loading"
              depressed
              class="ma-1 secondary-button"
              style="color: white; background-color: #b14949 !important"
              @click="signatureConfirmDialog = false"
            >
              {{ $t('Não') }}
            </v-btn>

            <v-btn
              :loading="loading"
              class="ma-1 primary-button"
              depressed
              color="#0F3582"
              style="color: white"
              @click="validateExecutorChecklist"
            >
              {{ $t('Sim') }}
            </v-btn>
          </div>
        </v-sheet>
      </div>
    </v-dialog>

    <v-card class="card-pad d-flex align-center mb-4" height="75">
      <v-btn depressed small text color="grey" @click="close">
        <v-icon x-small>mdi-arrow-left-bold</v-icon>
        {{ $t('Voltar') }}
      </v-btn>
    </v-card>

    <InstitutionInactive v-if="institutionInactive" />

    <DepartmentInactive v-if="departmentInactive" />

    <v-card
      class="card-pad error pa-0 pa-2 mt-4"
      v-if="currentChecklist.isValidatorSigned"
    >
      <v-row class="ma-0 px-4" dense justify="end">
        <v-col class="d-flex align-center my-2">
          <strong class="white--text">{{ $t('Checklist Validado') }}</strong>
        </v-col>
      </v-row>
    </v-card>

    <v-card
      class="card-pad error pa-0 pa-2 my-4"
      v-if="
        currentServiceOrder && currentServiceOrder.closeServiceOrderDateTime
      "
    >
      <v-row class="ma-0 px-4" dense justify="end">
        <v-col class="d-flex align-center my-2">
          <strong class="white--text">{{
            $t('Ordem de serviço fechada')
          }}</strong>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="card-pad pa-0 pb-2 mt-4">
      <v-row class="ma-0 px-4" dense justify="end">
        <v-col class="d-flex align-center my-2">
          <strong>{{ $t('Itens do Checklist') }}</strong>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="ma-2" dense>
        <v-col class="pt-0" cols="12">
          <label class="label d-block">{{ $t('Data de execução') }}</label>
          <v-menu
            ref="menuChecklistDate"
            v-model="menuChecklistDate"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                hide-details="auto"
                v-model="checklistDateFormatted"
                v-mask="['##/##/####']"
                :placeholder="$t('Data')"
                prepend-inner-icon="mdi-calendar"
                @blur="updateChecklistDateFromString"
                v-bind="attrs"
                v-on="on"
                autocomplete="off"
                outlined
                class="primary-input"
                :disabled="
                  institutionInactive ||
                  departmentInactive ||
                  currentChecklist.isValidatorSigned ||
                  (currentServiceOrder &&
                    currentServiceOrder.closeServiceOrderDateTime)
                "
                :error="checklistDateError"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="checklistDate"
              min="1900-01-01"
              @change="saveChecklistDate"
              no-title
              locale="pt"
            ></v-date-picker>
          </v-menu>
          <span class="date-span-error" v-if="checklistDateError">
            {{ $t('Data da execução é requerida') }}
          </span>
        </v-col>
        <v-col cols="12">
          <label class="label">{{ $t('Rodapé') }}</label>
          <v-textarea
            hide-details="auto"
            v-model="footnote"
            outlined
            class="text-area-input"
            rows="3"
            no-resize
            :disabled="
              currentChecklist.isValidatorSigned ||
              (currentServiceOrder &&
                currentServiceOrder.closeServiceOrderDateTime)
            "
            :rules="footnoteRules"
          ></v-textarea>
        </v-col>
      </v-row>
      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum item encontrado')"
        :headers="headersMobile"
        :items="checklistItems"
        class="main-table hidden-md-and-up"
        hide-default-footer
        disable-pagination
        :header-props="headerProps"
        :mobile-breakpoint="330"
        :single-expand="false"
        show-expand
        :expanded.sync="expanded"
        @click:row="(item, slot) => slot.expand(!slot.isExpanded)"
      >
        <template #[`item.checklistItem`]="{ item }">
          {{ item.itemName }}
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length" class="pa-3">
            <v-col class="ma-0 pa-0" cols="12">
              <p>
                <strong>{{ $t('Classe') }}:</strong>
                {{ item.itemClassName }}
              </p>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <div class="d-flex justify-space-between">
                <p>
                  <strong>{{ $t('Sim') }}:</strong>
                  <v-icon
                    :disabled="
                      currentChecklist.isValidatorSigned ||
                      (currentServiceOrder &&
                        currentServiceOrder.closeServiceOrderDateTime)
                    "
                    @click="setItemYes(item)"
                    :color="item.checklistResponse == 0 ? '#BBCF20' : ''"
                  >
                    {{
                      item.checklistResponse == 0
                        ? 'mdi-checkbox-marked-circle-outline'
                        : 'mdi-checkbox-blank-circle-outline'
                    }}
                  </v-icon>
                </p>
                <p>
                  <strong>{{ $t('Não') }}:</strong>
                  <v-icon
                    :disabled="
                      currentChecklist.isValidatorSigned ||
                      (currentServiceOrder &&
                        currentServiceOrder.closeServiceOrderDateTime)
                    "
                    @click="setItemNo(item)"
                    :color="item.checklistResponse == 1 ? '#B14949' : ''"
                  >
                    {{
                      item.checklistResponse == 1
                        ? 'mdi-checkbox-marked-circle-outline'
                        : 'mdi-checkbox-blank-circle-outline'
                    }}
                  </v-icon>
                </p>
                <p>
                  <strong>N/A:</strong>
                  <v-icon
                    :disabled="
                      currentChecklist.isValidatorSigned ||
                      (currentServiceOrder &&
                        currentServiceOrder.closeServiceOrderDateTime)
                    "
                    @click="setItemNotApplication(item)"
                    :color="item.checklistResponse == 2 ? '#426483' : ''"
                  >
                    {{
                      item.checklistResponse == 2
                        ? 'mdi-checkbox-marked-circle-outline'
                        : 'mdi-checkbox-blank-circle-outline'
                    }}
                  </v-icon>
                </p>
              </div>
            </v-col>
            <v-col class="ma-0 pa-0" cols="12">
              <strong>{{ $t('Observação') }}:</strong>
              <v-textarea
                hide-details="auto"
                class="ma-0 pa-0 text-area-input"
                no-resize
                rows="3"
                v-model="item.observation"
                :disabled="
                  currentChecklist.isValidatorSigned ||
                  (currentServiceOrder &&
                    currentServiceOrder.closeServiceOrderDateTime)
                "
                outlined
              ></v-textarea>
            </v-col>
          </td>
        </template>
      </v-data-table>

      <v-data-table
        :loading="loading"
        :loading-text="$t('Carregando...')"
        :no-data-text="$t('Nenhum item encontrado')"
        :headers="headers"
        :items="checklistItems"
        class="main-table mx-3 hidden-sm-and-down"
        hide-default-footer
        hide-default-header
        :header-props="headerProps"
        disable-pagination
      >
        <template #header="{ props, on }">
          <thead>
            <tr>
              <th
                class="text-center"
                v-for="header in props.headers"
                :key="header.value"
              >
                <v-simple-checkbox
                  v-if="header.value === 'data-table-select'"
                  v-model="props.everyItem"
                  :indeterminate="props.someItems && !props.everyItem"
                  color="purple"
                  @input="on['toggle-select-all']"
                ></v-simple-checkbox>

                <div>
                  <v-hover v-slot="{ hover }">
                    <div>
                      <span>{{ $t(header.text) }}</span>
                      <v-icon
                        v-if="
                          hover &&
                          header.value != 'data-table-select' &&
                          header.value != 'actions'
                        "
                        :disabled="
                          currentChecklist.isValidatorSigned ||
                          (currentServiceOrder &&
                            currentServiceOrder.closeServiceOrderDateTime)
                        "
                        color="white"
                        class="mx-2"
                        @click="on.sort(header.value)"
                      >
                        {{
                          props.options.sortBy.includes(header.value)
                            ? `mdi-chevron-down`
                            : `mdi-chevron-up`
                        }}
                      </v-icon>
                    </div>
                  </v-hover>
                </div>
              </th>
            </tr>
          </thead>
        </template>

        <template #[`item.checklistItem`]="{ item }">
          {{ item.itemName }}
        </template>

        <template #[`item.classItem`]="{ item }">
          {{ item.itemClassName }}
        </template>

        <template #[`item.checklistItemYes`]="{ item }">
          <v-icon
            :disabled="
              currentChecklist.isValidatorSigned ||
              (currentServiceOrder &&
                currentServiceOrder.closeServiceOrderDateTime)
            "
            @click="setItemYes(item)"
            :color="item.checklistResponse == 0 ? '#BBCF20' : ''"
          >
            {{
              item.checklistResponse == 0
                ? 'mdi-checkbox-marked-circle-outline'
                : 'mdi-checkbox-blank-circle-outline'
            }}
          </v-icon>
        </template>
        <template #[`item.checklistItemNo`]="{ item }">
          <v-icon
            :disabled="
              currentChecklist.isValidatorSigned ||
              (currentServiceOrder &&
                currentServiceOrder.closeServiceOrderDateTime)
            "
            @click="setItemNo(item)"
            :color="item.checklistResponse == 1 ? '#B14949' : ''"
          >
            {{
              item.checklistResponse == 1
                ? 'mdi-checkbox-marked-circle-outline'
                : 'mdi-checkbox-blank-circle-outline'
            }}
          </v-icon>
        </template>

        <template #[`item.checklistItemNotApplicaton`]="{ item }">
          <v-icon
            :disabled="
              currentChecklist.isValidatorSigned ||
              (currentServiceOrder &&
                currentServiceOrder.closeServiceOrderDateTime)
            "
            @click="setItemNotApplication(item)"
            :color="item.checklistResponse == 2 ? '#426483' : ''"
          >
            {{
              item.checklistResponse == 2
                ? 'mdi-checkbox-marked-circle-outline'
                : 'mdi-checkbox-blank-circle-outline'
            }}
          </v-icon>
        </template>

        <template #[`item.checklistItemObs`]="{ item }">
          <v-textarea
            hide-details="auto"
            class="ml-5 my-2 text-area-input"
            no-resize
            rows="3"
            v-model="item.observation"
            outlined
          ></v-textarea>
        </template>
      </v-data-table>
    </v-card>

    <div class="mt-2 text-center" flat>
      <v-btn
        v-show="currentChecklist.ChecklistId != null"
        v-if="!currentChecklist.isValidatorSigned"
        color="#BBCF20"
        @click="validateChecklist"
        depressed
        class="mr-4 hidden-md-and-up"
        :loading="validateLoading"
        :disabled="institutionInactive || departmentInactive || inputDisabled"
      >
        {{ $t('Validar Checklist') }}
      </v-btn>

      <div class="d-flex mt-4">
        <v-btn
          class="quaternary-button"
          depressed
          color="#B14949"
          @click="close"
        >
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          color="#426483"
          @click="isEditing ? submit() : openSignatureModal()"
          class="primary-button mr-0"
          :loading="loading"
          :disabled="
            institutionInactive ||
            departmentInactive ||
            inputDisabled ||
            currentChecklist.isValidatorSigned ||
            (currentServiceOrder &&
              currentServiceOrder.closeServiceOrderDateTime)
          "
        >
          {{ $t('Salvar') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<style scoped>
.v-application .primary--text {
  color: #707070 !important;
  caret-color: #707070 !important;
}

.date-span-error {
  color: #ff5252;
  font-size: 12px;
  margin-top: 4px;
  display: block;
}

.v-data-table .v-icon.v-icon {
  font-size: 2.2rem !important;
}
</style>

<script>
import ApiService from '../../../../../services/ApiService'
import Utils from '../../../../../Utils/FormatDate'
import InstitutionInactive from '../../../Institutions/components/institutionInactive/institutionInactive.vue'
import DepartmentInactive from '../../../Department/deparmentInactive/departmentInactive.vue'
import SignatureScreen from '../../../../../components/SignatureScreen.vue'

export default {
  components: {
    InstitutionInactive,
    DepartmentInactive,
    SignatureScreen,
  },

  async created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionInactive = this.institution.status == 1
    this.institutionId = this.institution.id
    this.currentUser = JSON.parse(localStorage.getItem('user'))

    this.inputDisabled =
      this.institution.userType > 3 && this.institution.userType < 8
    this.currentChecklist = JSON.parse(sessionStorage.getItem('checklist'))
    this.currentServiceOrder = JSON.parse(
      sessionStorage.getItem('serviceOrder')
    )

    if (!this.currentChecklist || !this.currentServiceOrder) {
      this.$router.push('/serviceOrders')
      return
    }

    if (this.currentChecklist.ChecklistId) this.getChecklist()

    this.getItemsChecklist()
    if (this.currentChecklist.EquipmentId) this.getDepartmentStatus()

    await this.getInstitution()

    this.footnote = this.institution.checklistFootNote
      ? this.institution.checklistFootNote
      : `EQUIPACARE SERVICOS ESPECIALIZADOS DE APOIO TECNICO LTDA CNPJ: 17.040.595/0001-01
Endereço: R. 41-C, 611 - Vila Santa Cecília, Volta Redonda - RJ, 27255-430
Telefone: (24) 3348-7157`
  },

  data: () => ({
    institution: {},
    signatureErrorDialog: false,
    currentServiceOrder: {},
    option: 0,
    signatureConfirmDialog: false,
    footnote: '',
    footnoteRules: [(v) => !!v || 'Rodapé é obrigatório'],
    errorMessage: '',
    expanded: [],
    error: false,
    showError: false,
    isEditing: false,
    loading: false,
    validateLoading: false,
    institutionInactive: false,
    departmentInactive: false,
    inputDisabled: false,
    checklistDateError: false,
    institutionId: null,
    checklistDate: null,
    checklistDateFormatted: '',
    menuChecklistDate: false,
    checklistItems: [],
    checklist: {},
    currentChecklist: {},
    currentUser: {},
    headers: [
      {
        text: '',
        align: 'center',
        value: '',
        sortable: false,
      },
      {
        text: 'Item',
        align: 'center',

        value: 'checklistItem',
        sortable: false,
      },
      {
        text: 'Classe',
        align: 'center',

        value: 'classItem',
        width: '200',
        sortable: false,
      },
      {
        text: 'Sim',
        align: 'center',

        value: 'checklistItemYes',
        width: '50',
        sortable: false,
      },
      {
        text: 'Não',

        align: 'center',
        value: 'checklistItemNo',
        width: '50',
        sortable: false,
      },
      {
        text: 'N/A',

        align: 'center',
        value: 'checklistItemNotApplicaton',
        width: '50',
        sortable: false,
      },
      {
        text: 'Observação',

        align: 'center',
        value: 'checklistItemObs',
        width: '300',
        sortable: false,
      },
    ],
    headersMobile: [
      {
        text: 'Item',
        align: 'center',

        value: 'checklistItem',
        sortable: false,
      },
    ],
    headerProps: {
      sortByText: 'Ordenar por',
    },
    apiService: new ApiService(),
  }),

  methods: {
    parseDate(dateString) {
      if (!dateString || dateString.length < 10) return null

      const parts = dateString.split('/')
      if (parts.length !== 3) return null

      const day = parts[0]
      const month = parts[1]
      const year = parts[2]

      return `${year}-${month}-${day}`
    },

    formatDateToBR(dateString) {
      if (!dateString) return ''

      const parts = dateString.split('-')
      if (parts.length !== 3) return ''

      return `${parts[2]}/${parts[1]}/${parts[0]}`
    },

    updateChecklistDateFromString() {
      if (
        this.checklistDateFormatted &&
        this.checklistDateFormatted.length === 10
      ) {
        this.checklistDate = this.parseDate(this.checklistDateFormatted)
        this.checklistDateError = false
      }
    },

    saveChecklistDate(date) {
      this.checklistDateFormatted = this.formatDateToBR(date)
      this.menuChecklistDate = false
      this.checklistDateError = false
    },

    getFullChecklistDateTime() {
      if (!this.checklistDate) return null
      const [year, month, day] = this.checklistDate.split('-')
      return new Date(
        parseInt(year),
        parseInt(month) - 1,
        parseInt(day),
        0,
        0,
        0
      )
    },

    openSignatureModal() {
      const answers = this.checklistItems.map(
        (checklist) => checklist.checklistResponse
      )
      if (answers.includes(null)) {
        window.scrollTo(0, 0)
        this.$toast.error(
          'Existe um ou mais items sem resposta, favor verificar'
        )
      } else if (!this.checklistDate) {
        this.checklistDateError = true
        this.$toast.error(
          'Adicione a data de execução do Checklist para prosseguir!'
        )
      } else {
        this.signatureConfirmDialog = true
      }
    },

    async getInstitution() {
      await this.apiService
        .get(`institution/${this.institutionId}`)
        .then((response) => {
          this.institution = response.content
        })
    },

    async getChecklist() {
      await this.apiService
        .get(`checklistServiceOrder/${this.currentChecklist.ChecklistId}`)
        .then((response) => {
          this.checklist = response.content
          if (this.checklist.checklistDate) {
            const date = new Date(this.checklist.checklistDate)

            const year = date.getFullYear()
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const day = String(date.getDate()).padStart(2, '0')
            this.checklistDate = `${year}-${month}-${day}`

            this.checklistDateFormatted = `${day}/${month}/${year}`
          }
        })
    },

    close() {
      this.$router.push('checklists')
    },

    showErrorAlert(message) {
      this.errorMessage = message
      this.showError = true

      setTimeout(() => {
        this.showError = false
      }, 3000)
    },

    async getItemsChecklist() {
      this.loading = true

      const checklistServiceOrder = {
        ServiceOrderId: this.currentChecklist.ServiceOrderId,
        ChecklistId: this.currentChecklist.ChecklistId,
        ChecklistTemplateId: this.currentChecklist.ChecklistTemplate
          ? this.currentChecklist.ChecklistTemplate.checklistTemplateId
          : null,
      }

      await this.apiService
        .post('checklistServiceOrder/items', checklistServiceOrder)
        .then((response) => {
          this.checklistItems = response.content
          this.currentChecklist.checklistId = this.checklistItems
            .map((checklist) => checklist.checklistId)
            .filter((id) => id != null)
          this.loading = false
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getDepartmentStatus() {
      await this.apiService
        .get(
          `equipment/${this.institutionId}/${this.currentChecklist.EquipmentId}`
        )
        .then((response) => {
          this.departmentInactive = response.content.department.status == 1
        })
    },

    async validateExecutorChecklist(data) {
      console.log('[validateExecutorChecklist] option:', this.option)
      console.log(
        '[validateExecutorChecklist] data (assinatura desenhada):',
        !!data,
        data
      )

      if (this.option == 0) {
        console.log(
          '[validateExecutorChecklist] → branch 0: usar assinatura do usuário logado'
        )
        if (this.currentUser.signatureImage) {
          this.currentChecklist.isExecutorSigned = true
          this.currentChecklist.executingUserId = this.currentUser.id
          this.currentChecklist.executorName =
            this.currentChecklist.executorName

          this.submit()
          this.signatureConfirmDialog = false
        } else {
          this.currentChecklist.executingUserId = this.currentUser.id
          this.signatureErrorDialog = true
        }
      } else if (this.option == 1) {
        console.log(
          '[validateExecutorChecklist] → branch 1: assinar via touchscreen'
        )
        console.log(
          '[validateExecutorChecklist] executorImage que será salvo:',
          data
        )
        this.currentChecklist.isExecutorSigned = true
        this.currentChecklist.executingUserId = this.currentUser.id
        this.currentChecklist.executorImage = data
        this.currentChecklist.executorName = this.currentChecklist.executorName

        this.submit()
        this.signatureConfirmDialog = false
      } else {
        console.log(
          '[validateExecutorChecklist] → branch 2: usar assinatura do responsável pela O.S.'
        )
        if (
          this.currentServiceOrder &&
          this.currentServiceOrder.responsibleName
        ) {
          this.apiService
            .get(`byName/${this.currentServiceOrder.responsibleName}`)
            .then((response) => {
              this.currentChecklist.isExecutorSigned = true
              this.currentChecklist.executingUserId = response.content.id
              this.currentChecklist.executorName = response.content.name

              this.submit()
              this.signatureConfirmDialog = false
            })
        } else {
          this.$toast.error(
            'Nenhum responsável encontrado na Ordem de Serviço!'
          )
        }
      }
    },

    async validateChecklist() {
      this.validateLoading = true
      if (this.currentUser.signatureImage) {
        const checklist = {
          Id: this.currentChecklist.checklist.id,
          isValidatorSigned: true,
          ValidatorUserId: this.currentUser.id,
        }

        await this.apiService
          .post('checklistServiceOrder/validate', checklist)
          .then(() => {
            this.validateLoading = false
            this.close()
          })
      }
    },

    async submit() {
      const answers = this.checklistItems.map(
        (checklist) => checklist.checklistResponse
      )

      if (answers.includes(null)) {
        window.scrollTo(0, 0)
        this.$toast.error(
          'Existe um ou mais items sem resposta, favor verificar'
        )
      } else if (!this.checklistDate) {
        this.checklistDateError = true
        this.$toast.error(
          'Adicione a data de execução do Checklist para prosseguir!'
        )
      } else {
        const fullDateTime = this.getFullChecklistDateTime()

        const checklistModel = {
          ChecklistId: this.currentChecklist.checklistId[0],
          ChecklistServiceOrders: this.checklistItems,
          footnote: this.footnote,
          isExecutingSigned: !!this.currentChecklist.executingUserId,
          ExecutingUserId: this.currentChecklist.executingUserId,
          executorName: this.currentChecklist.executorName,
          executorImage: this.currentChecklist.executorImage,
          ChecklistDate: Utils.nowDatetimeFormat(fullDateTime),
        }

        await this.apiService
          .post('checklistServiceOrder/save', checklistModel)
          .then((response) => {
            this.$toast.success('Checklist da O.S. salvo! 📝')
            const checklist = response.content
            checklist.isExecutingSigned = checklistModel.isExecutingSigned
            checklist.executingUserId = checklistModel.ExecutingUserId
            this.generatePDF(checklist)
            this.$router.push(
              `/editServiceOrder/${this.currentChecklist.ServiceOrderId}`
            )
          })
          .catch((err) => {
            this.errorMessage = err.body.message
            this.error = true

            setTimeout(() => {
              this.error = false
            }, 4000)
          })
      }
    },

    async generatePDF(checklist) {
      const route = this.$router.resolve({
        path: `/printChecklist/${checklist.id}`,
      })
      window.open(route.href, '_blank')
    },

    formatDate(date) {
      return Utils.moment(date)
    },

    setItemYes(item) {
      this.$set(item, 'checklistResponse', 0)
    },
    setItemNo(item) {
      this.$set(item, 'checklistResponse', 1)
    },
    setItemNotApplication(item) {
      this.$set(item, 'checklistResponse', 2)
    },
  },

  computed: {},

  watch: {
    checklistDate: {
      deep: true,
      handler() {
        this.checklistDateError = false
      },
    },
  },
}
</script>
